var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongWenjianjia2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.559 14H2.44a.5.5 0 01-.496-.438l-.875-7A.5.5 0 011.566 6h12.868a.5.5 0 01.496.562l-.875 7a.5.5 0 01-.496.438z",
    stroke: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.5V3a.5.5 0 01.5-.5h3.086a1 1 0 01.707.293l.414.414a1 1 0 00.707.293H13.5a.5.5 0 01.5.5v2.5",
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_wenjianjia2.ad3418cf.svg";
export { SvgTongyongWenjianjia2 as ReactComponent };